var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"showImage"}},[(_vm.showBigImage)?_c('div',{staticClass:"show-big",on:{"click":_vm.close}},[_c('img',{attrs:{"id":"bigImage","src":_vm.url},on:{"click":_vm.close}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }